<div class="layout-sidebar" [class.ecms-workspace-sidebar]="workspaceNavigation">

    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
